import { STORAGE_KEY } from 'constants/browserStorageKeys';
import {
  getLocalStorage,
  removeLocalStorage,
  setLocalStorage,
} from './localStorage';
import {
  getSessionStorage,
  removeSessionStorage,
  setSessionStorage,
} from './sessionStorage';

export let withCrossTabSync = true;

export const setCrossTabSync = (withSync = true) => {
  withCrossTabSync = withSync;
};

export const getStorageItem = (key: STORAGE_KEY) => {
  if (withCrossTabSync) return getLocalStorage(key);
  return getSessionStorage(key);
};

export const setStorageItem = (key: STORAGE_KEY, value: any) => {
  if (withCrossTabSync) return setLocalStorage(key, value);
  return setSessionStorage(key, value);
};

export const removeStorageItem = (key: STORAGE_KEY) => {
  if (withCrossTabSync) return removeLocalStorage(key);
  return removeSessionStorage(key);
};
